import { useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

// Todos os endpoints de template de prescrição no quarkus.
export function usePrescriptionTemplates() {
  const fetchClinic = useCallback(() => quarkusApi.get('/clinic', authHeader()), []);

  const fetchDentists = useCallback(() => quarkusApi.get('/dentists/combobox', authHeader()), []);

  const fetchTemplatesFromClinic = useCallback(
    (clinicId) =>
      quarkusApi.get(`/clinic-prescription-template/from-clinic/${clinicId}`, authHeader()),
    [],
  );

  const fetchTemplatesFromDentists = useCallback(
    () => quarkusApi.get('/clinic-prescription-template/from-dentists', authHeader()),
    [],
  );

  const updateMode = useCallback(
    (prescriptionTemplateMode) =>
      quarkusApi.patch(
        '/clinic/prescription-template-mode',
        { prescriptionTemplateMode },
        authHeader(),
      ),
    [],
  );

  const uploadClinicTemplate = useCallback(
    (formData) => quarkusApi.post('/clinic-prescription-template/clinic', formData, authHeader()),
    [],
  );

  const uploadDentistTemplate = useCallback(
    (formData) => quarkusApi.post('/clinic-prescription-template/dentist', formData, authHeader()),
    [],
  );

  const deleteTemplate = useCallback(
    (templateId) => quarkusApi.delete(`/clinic-prescription-template/${templateId}`, authHeader()),
    [],
  );

  return {
    fetchClinic,
    fetchDentists,
    fetchTemplatesFromClinic,
    fetchTemplatesFromDentists,
    updateMode,
    uploadClinicTemplate,
    uploadDentistTemplate,
    deleteTemplate,
  };
}
